import { useEffect } from "react";
import { loadUet } from "./analytics";

export default function UetBootstrap() {
  useEffect(() => { loadUet(); }, []);
  return null;
}
